/**
 * Implements collapsed boxes.
 */
class Collapsed {
	constructor( box ) {
		this.$box = jQuery( box );

		var title = this.$box.data( 'title' );
		if ( ! title ) {
			return;
		}
		this.id = this.$box.attr( 'id' );
		if ( ! this.id ) {
			this.id = 'collapsed-' + Math.random().toString( 36 ).substr( 2, 9 );
		}
		var collapsedId = this.id + Math.random().toString( 36 ).substr( 2, 9 );
		var control = jQuery(
			'<button class="iportal-collapsed__title btn-link btn btn-block collapsed" type="button" data-toggle="collapse" '
				+ 'data-target="#' + collapsedId + '-content" '
				+ `>` + title + `</button>` );

		// Redraw dataTables on uncollapsing
		this.$box.on( 'show.bs.collapse,shown.bs.collapse', function( event ) {
			setTimeout( function() {
				var tables = jQuery( event.target ).find( '.dataTable' );
				if ( tables.length && tables.DataTable !== undefined ) {
					tables.DataTable().columns.adjust().draw();
				}
			} );
		} );

		this.$box
			.wrapInner( '<div class="collapse iportal-collapsed__content" id="' + collapsedId  + '-content"></div>' )
			.prepend( control )
			.addClass( 'border-top border-bottom' );
		this.$collapse = this.$box.find( '.collapse' );
		this.$collapse.append( this.createToTopButton() );

		window.addEventListener(
			'hashchange',
			this.onHashChange.bind( this )
		);
		this.onHashChange();
	};

	/**
	 * Creates button used to collapse the box.
	 *
	 * If the box's header is not in view, scroll to it on collapse.
	 */
	createToTopButton( clickHandler ) {
		var chevron = document.createElement( 'i' );
		chevron.classList.add( 'fa', 'fa-chevron-up' );
		var button = document.createElement( 'a' );
		button.classList.add(
			'iportal-collapsed__to-top-button',
			'btn',
			'btn-sm',
			'btn-outline-primary'
		);
		button.setAttribute( 'role', 'button' );
		button.href = '#' + this.id;
		button.appendChild( chevron );
		button.addEventListener( 'click', (event) => {
			if ( this.$box[0].getBoundingClientRect().top >= 0 ) {
				event.preventDefault();
				event.stopPropagation();
			}
			this.$collapse.collapse( 'hide' );
		} );
		return button;
	}

	/**
	 * Handler for hash change events.
	 *
	 * Open the box if it or any content inside is referenced by the hash.
	 */
	onHashChange() {
		if ( window.location.hash === '#' + this.id
				 || this.$box.find( window.location.hash ).length > 0
			 ) {
			this.$box.children( '.collapse' ).collapse( 'show' );
		}
	};
}

export default Collapsed;
